/* eslint-disable import/export */
import Paper from './Paper';
export * from './Paper';
export default Paper;